export default __webpack_public_path__ + "static/media/participation.f97eacb0.svg";